import React from 'react'

import './ProductSearchError.scss'

export const SEARCH_ERROR_NO_QUERY = 0
export const SEARCH_ERROR_NO_RESULT = 1

const defaultErrorMessage = {
  title: '',
  description: null
}

const makeErrorMessage = (errorCode: number) => {
  switch (errorCode) {
  case SEARCH_ERROR_NO_QUERY:
    return {
      ...defaultErrorMessage,
      title: 'Введите поисковый запрос',
      description: 'Нам нужно хотя бы 3 символа 😉'
    }
  case SEARCH_ERROR_NO_RESULT:
    return {
      ...defaultErrorMessage,
      title: 'Товаров не найдено 😔',
      description: 'Попробуйте поискать по другому 👍'
    }
  default:
    return {
      ...defaultErrorMessage,
      title: 'Что-то пошло не так... 🤦‍♂️'
    }
  }
}

export interface ProductSearchError {
  className?: string
  error: number
}

export default function ProductSearchError ({
  className = '',
  error
}: ProductSearchError) {
  const { title = '', description = null } = makeErrorMessage(error)

  return (
    <div className={`ProductSearchError ${className}`}>
      <p className="ProductSearchError__Title">{title}</p>
      {description && (
        <p className="ProductSearchError__Description">{description}</p>
      )}
    </div>
  )
}
